module.exports = __webpack_public_path__ + "static/media/qr-img.a89a089b.png";